import React from "react";
import cx from "./cx";

const TONE_CLASS = { warn: 'rev-alert--warn', err: 'rev-alert--err', info: 'rev-alert--info', ok: 'rev-alert--ok' };

const TONE_ICON = { warn: 'warning', err: 'error', info: 'info', ok: 'check_circle' };

/**
 * Aviso en línea.
 *  - tone: 'warn' | 'err' | 'info' | 'ok'
 *  - icon: nombre de material-icons a la izquierda; por defecto el del tono
 *    (warn warning, err error, info info, ok check_circle). `null` lo quita.
 *  - title: si se da, título + children van en un bloque; si no, children directos
 *  - actions: nodo a la derecha (botón), fuera del bloque de texto
 */
const RevAlert = ({ tone, icon, title, actions, className, children, ...rest }) => {
    const iconName = icon === undefined ? TONE_ICON[tone] : icon;
    return (
        <div className={cx('rev-alert', TONE_CLASS[tone], className)} {...rest}>
            {iconName && <span className="material-icons rev-alert__icon" aria-hidden="true">{iconName}</span>}
            {title
                ? <div><div className="rev-alert__title">{title}</div>{children}</div>
                : children}
            {actions}
        </div>
    );
};

export default RevAlert;
